import { eachDayOfInterval, format, max, min } from 'date-fns';
import { ja } from 'date-fns/locale';
import React from 'react';

import { CmCard, CmHeading } from '@/components/uiParts';
import { ChartDatum } from '@/domain/models/Chart';
import { KPI } from '@/domain/models/KPI';
import { SalesReport } from '@/domain/models/SalesReport';

import { ChartContainer, LineChart } from './Charts';

interface Props {
  salesReport: SalesReport;
}

const rangeFromMinToMax = (
  dateList: Date[],
  dailySalesMap: Map<string, number>
): { x: string; y: number }[] => {
  const minDate = min(dateList);
  const maxDate = max(dateList);

  // Generate a complete range of dates from min to max
  const range = eachDayOfInterval({ start: minDate, end: maxDate });

  // Map each date in the range to its corresponding sales value or 0 if missing
  return range.map((date) => {
    const dateStr = format(date, 'yyyy-MM-dd', { locale: ja });
    return {
      x: dateStr, // x-axis value
      y: dailySalesMap.get(dateStr) || 0, // y-axis value
    };
  });
};

const projectToTotalPriceDatumByDate = (
  salesReport: SalesReport
): ChartDatum => {
  // Create a map for faster lookups
  const dailySalesMap = new Map(
    salesReport.daily_sales.map((item) => [item.date, item.total_sales])
  );

  // Extract date keys and convert them to Date objects
  const dateList = Array.from(dailySalesMap.keys()).map(
    (date) => new Date(date)
  );

  // Generate chart data
  const data = rangeFromMinToMax(dateList, dailySalesMap);

  return {
    id: 'totalPrice',
    data,
  };
};
export const SalesTransition: React.FC<Props> = ({ salesReport }) => {
  const totalPriceData = projectToTotalPriceDatumByDate(salesReport);
  return (
    <CmCard>
      <CmHeading as="h2">売上推移</CmHeading>
      <ChartContainer mt={5} height="250px" width="100%">
        {totalPriceData && (
          <LineChart
            data={[totalPriceData]}
            yAxisFormat="currency"
            yLegend={KPI[totalPriceData.id]}
            legendRequired={false}
          />
        )}
      </ChartContainer>
    </CmCard>
  );
};
